import React from 'react'
import { Image, Transformation } from 'cloudinary-react'
import { FormattedMessage } from 'react-intl'
import { useStyles } from './SchoolCard_style'
import { Box, Typography } from '@material-ui/core'
import IconFactory from 'icons/IconFactory/IconFactory'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import { MEDIUM_SMALL_SIZE, SMALLER_SIZE } from 'assets/CloudinaryURLHelper'
import SVGFactory from 'icons/SVGFactory/SVGFactory'
import Sanitizer from 'assets/Sanitizer'
import { GetProgramTypeString } from 'pages/SchoolShow/SchoolShowHelper'

const SchoolCard = (props) => {
    const { school } = props

    const cardImageCloudinaryKey = school?.card_image?.cloudinary_key
    const bannerImageCloudinaryKey = school?.banner_image?.cloudinary_key
    const defaultImage = 'placeholders/other_industries.png'
    const cardImageAlt = school?.card_image?.alt || `card image ${school.name}`
    const formattedSchoolDescription = Sanitizer.RemoveHTML(school.card_description?.substring(0, 300))
    const hasSchoolLogo = !!school.logo
    const classes = useStyles({ hasSchoolLogo })

    return (
        <RouteMapLink showItemType='education' showItemUrl={school.slug} className={classes.routeMapLinkStyle}>
            <Box className={classes.container} key={school.id}>
                <span className={classes.schoolCardImage} role='img' aria-label={`card image ${school.name}`}>
                    <Image
                        cloudName="studentbe"
                        className={classes.cardMedia}
                        publicId={cardImageCloudinaryKey || bannerImageCloudinaryKey ||defaultImage}
                        alt={cardImageAlt}
                    >
                        <Transformation flags="progressive" fetchFormat="auto" height={MEDIUM_SMALL_SIZE} quality="auto:good" crop="fill" />
                        <Transformation defaultImage={defaultImage.replace('/', ':')} />
                    </Image>
                    {hasSchoolLogo &&
                        <Box className={classes.schoolLogo}>
                            <Image cloudName="studentbe" publicId={school.logo.cloudinary_key} alt={`School logo ${school.name}`}>
                                <Transformation flags="progressive" fetchFormat="auto" width={SMALLER_SIZE} quality="auto:good" crop="fill" gravity="center" />
                            </Image>
                        </Box>
                    }
                    {school.paid && school.has_videos &&
                        <Box className={classes.paidIcon}>
                            <SVGFactory name='video' width="25" height="25" />
                        </Box>
                    }
                </span>
                <Box className={classes.schoolInfoContainer}>
                    <Box className={classes.textBox}>
                        <Box>
                            <Typography variant='h3' component='p' className={classes.schoolName}>
                                {school.name}
                            </Typography>
                            <Box className={classes.schoolDetails}>
                                <IconFactory icon='attachment' fontSize='14px' />
                                <Typography component='span'>{GetProgramTypeString(school.program_types)}</Typography>
                            </Box>
                        </Box>
                        <Typography
                            variant='body2'
                            className={classes.schoolDescription}
                            dangerouslySetInnerHTML={{ __html: formattedSchoolDescription }}
                        />
                        {school.paid &&
                            <RouteMapLink
                                showItemType='education'
                                showItemUrl={school.slug}
                            >
                                <Typography className={classes.learnMoreLink} component='span'>
                                    <FormattedMessage id='school_card.link'/>
                                </Typography>
                            </RouteMapLink>
                        }
                    </Box>
                </Box>
            </Box>
        </RouteMapLink>
    )
}

export default SchoolCard
